"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5466],{

/***/ 83826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11496);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13362);
// @mui




// ----------------------------------------------------------------------
var InputStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "stretchStart";
    }
})(function(param) {
    var stretchStart = param.stretchStart, theme = param.theme;
    return {
        "& .MuiOutlinedInput-root": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            transition: theme.transitions.create([
                "box-shadow",
                "width"
            ], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.shorter
            }),
            "&.Mui-focused": {
                boxShadow: theme.customShadows.z12
            }
        }, stretchStart && {
            width: stretchStart,
            "&.Mui-focused": (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                boxShadow: theme.customShadows.z12
            }, theme.breakpoints.up("sm"), {
                width: stretchStart + 60
            })
        }),
        "& fieldset": {
            borderWidth: "1px !important",
            borderColor: "".concat(theme.palette.grey[50032], " !important")
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (InputStyle);


/***/ }),

/***/ 72579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QuestionHeaderToolbar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(153);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18972);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(87109);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(49624);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(87918);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(13362);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var _components_Iconify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22554);
/* harmony import */ var _components_InputStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83826);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9671);
/* harmony import */ var _redux_slices_blog_blog_question__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29061);
/* harmony import */ var _redux_slices_blog_blog_tag__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30910);
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/prop-types */ 




// components







// ----------------------------------------------------------------------
function QuestionHeaderToolbar() {
    var ref;
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().translate;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var search = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.blogQuestion;
    }).search;
    var ref1 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.blogTag;
    }), tags = ref1.tags, searchTag = ref1.search, isLoading = ref1.isLoading;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"), sortBy = ref2[0], setSortBy = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timeout = setTimeout(function() {
            dispatch((0,_redux_slices_blog_blog_tag__WEBPACK_IMPORTED_MODULE_7__/* .getTags */ .NJ)());
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        searchTag
    ]);
    var handleFilterTags = function(_, value) {
        dispatch((0,_redux_slices_blog_blog_tag__WEBPACK_IMPORTED_MODULE_7__/* .setTagSearch */ .tx)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, searchTag), {
            page: 0,
            value: value
        })));
    };
    var onFilterName = function(value) {
        dispatch((0,_redux_slices_blog_blog_question__WEBPACK_IMPORTED_MODULE_6__/* .setQuestionSearch */ .y4)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, search), {
            page: 0,
            value: value
        })));
    };
    var onChangeTags = function(tags) {
        var tagIds = tags === null || tags === void 0 ? void 0 : tags.map(function(t) {
            return t.id;
        }).toString();
        dispatch((0,_redux_slices_blog_blog_question__WEBPACK_IMPORTED_MODULE_6__/* .setQuestionSearch */ .y4)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, search), {
            page: 0,
            tags: tags,
            filterBys: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, search.filterBys), {
                tagIds: tagIds
            })
        })));
    };
    var handleChangeSort = function(event) {
        var value = event.target.value;
        var orders = [
            {
                order: "desc",
                property: "createdAt"
            }
        ];
        if (value === "0") orders = [
            {
                order: "desc",
                property: "createdAt"
            }
        ];
        else if (value === "1") orders = [
            {
                order: "asc",
                property: "createdAt"
            }
        ];
        else orders = [
            {
                order: "desc",
                property: "createdAt"
            }
        ];
        dispatch((0,_redux_slices_blog_blog_question__WEBPACK_IMPORTED_MODULE_6__/* .setQuestionSearch */ .y4)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, search), {
            page: 0,
            orders: orders
        })));
        setSortBy(value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        spacing: 2,
        direction: {
            xs: "column",
            md: "row"
        },
        sx: {
            mt: 6,
            mb: 3
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        variant: "caption",
                        children: [
                            translate("label.sortBy"),
                            ": "
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        variant: "standard",
                        value: sortBy,
                        size: "small",
                        sx: {
                            fontSize: 12,
                            fontWeight: "bold",
                            ml: 1,
                            pt: 1
                        },
                        disableUnderline: true,
                        onChange: handleChangeSort,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "0",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByNew")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "1",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByOld")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "2",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByLike")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                flexGrow: 1
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_InputStyle__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                size: "small",
                sx: {
                    minWidth: {
                        md: 200
                    }
                },
                value: search.value || "",
                onChange: function(event) {
                    return onFilterName(event.target.value);
                },
                placeholder: translate("label.search"),
                InputProps: {
                    startAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        position: "start",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            icon: "eva:search-fill",
                            sx: {
                                color: "text.disabled",
                                width: 20,
                                height: 20
                            }
                        })
                    }),
                    endAdornment: ((ref = search.value) === null || ref === void 0 ? void 0 : ref.trim().length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        position: "end",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            icon: "ic:baseline-clear",
                            sx: {
                                color: "text.disabled",
                                width: 20,
                                height: 20,
                                cursor: "pointer"
                            },
                            onClick: function() {
                                return onFilterName("");
                            }
                        })
                    })
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                size: "small",
                sx: {
                    minWidth: {
                        md: 150
                    }
                },
                multiple: true,
                onChange: function(_, newValue) {
                    return onChangeTags(newValue);
                },
                options: tags === null || tags === void 0 ? void 0 : tags.map(function(param) {
                    var id = param.id, title = param.title, type = param.type;
                    return {
                        id: id,
                        title: title,
                        type: type
                    };
                }),
                getOptionLabel: function(option) {
                    return option.title || "";
                },
                isOptionEqualToValue: function(option, value) {
                    return option.id === value.id;
                },
                loading: isLoading,
                value: (search === null || search === void 0 ? void 0 : search.tags) || [],
                onInputChange: handleFilterTags,
                renderTags: function(value, getTagProps) {
                    return value.map(function(option, index) {
                        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, getTagProps({
                            index: index
                        })), {
                            key: option.id,
                            size: "small",
                            label: "".concat(option.title)
                        }));
                    });
                },
                renderInput: function(params) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        label: translate("label.topic")
                    }, params));
                }
            })
        ]
    });
}


/***/ }),

/***/ 54273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QuestionInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15861);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9671);
// @mui


// utils

// ----------------------------------------------------------------------
function QuestionInfo() {
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().translate;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            spacing: 2,
            sx: {
                px: 3,
                py: 2
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                variant: "body2",
                children: translate("question.description")
            })
        })
    });
}


/***/ }),

/***/ 40183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QuestionNewForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56254);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74231);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95496);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87536);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(31812);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26447);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(11496);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25617);
/* harmony import */ var _components_hook_form_RHFAutoComplete__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69541);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9671);
/* harmony import */ var _redux_slices_blog_blog_tag__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30910);
/* harmony import */ var _components_hook_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54397);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77364);
/* harmony import */ var _redux_slices_blog_blog_question__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29061);
/* harmony import */ var _service_blog_blog_question_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(18741);
/* eslint-disable react/prop-types */ 







// form


// @mui







// components




// ----------------------------------------------------------------------
var RootStyles = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(1),
        borderRadius: Number(theme.shape.borderRadius)
    };
});
function QuestionNewForm() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_1__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().translate;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)();
    var isAuthenticated = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)().isAuthenticated;
    var search = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.blogQuestion;
    }).search;
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.blogTag;
    }), tags = ref.tags, searchTag = ref.search, isLoadingTag = ref.isLoading;
    var NewItemSchema = yup__WEBPACK_IMPORTED_MODULE_3__/* .object */ .Ry().shape({
        description: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().required(translate("validation.required"))
    });
    var defaultValues = {
        id: "",
        tags: [],
        description: "",
        status: "ACTIVE"
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var timeout = setTimeout(function() {
            dispatch((0,_redux_slices_blog_blog_tag__WEBPACK_IMPORTED_MODULE_9__/* .getTags */ .NJ)());
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        searchTag
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    var handleFilterTitleTag = function(_, value) {
        dispatch((0,_redux_slices_blog_blog_tag__WEBPACK_IMPORTED_MODULE_9__/* .setTagSearch */ .tx)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, searchTag), {
            value: value,
            page: 0,
            filterBys: {
                type: null
            }
        })));
    };
    var methods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_4__/* .yupResolver */ .X)(NewItemSchema),
        defaultValues: defaultValues
    });
    var reset = methods.reset, handleSubmit = methods.handleSubmit, isSubmitting = methods.formState.isSubmitting;
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function(data) {
            var resp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_20__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isAuthenticated) {
                            enqueueSnackbar(translate("label.signinToGPLX"), {
                                variant: "error"
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            (0,_service_blog_blog_question_service__WEBPACK_IMPORTED_MODULE_13__/* .createQuestionAPI */ .FY)(data)
                        ];
                    case 1:
                        resp = _state.sent();
                        if (resp.code === "200") {
                            reset();
                            enqueueSnackbar(translate("message.createSuccess"));
                            dispatch((0,_redux_slices_blog_blog_question__WEBPACK_IMPORTED_MODULE_12__/* .setQuestionSearch */ .y4)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, search), {
                                page: 0,
                                value: "",
                                filterBys: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, search.filterBys), {
                                    tagIds: null
                                })
                            })));
                        } else enqueueSnackbar("".concat(resp.code, " - ").concat(resp.message), {
                            variant: "error"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .FormProvider */ .RV, {
        methods: methods,
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(RootStyles, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .RHFEditor */ .LM, {
                    name: "description",
                    simple: true,
                    sx: {
                        "& .ql-editor": {
                            height: 90,
                            minHeight: 80
                        },
                        "& .ql-toolbar.ql-snow": {
                            padding: "0px 8px"
                        },
                        "& .ql-formats": {
                            marginRight: "0px!important"
                        },
                        "& .ql-container.ql-snow": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, theme.typography.body1)
                    },
                    placeholder: translate("question.create")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                    direction: "row",
                    spacing: 2,
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_hook_form_RHFAutoComplete__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            name: "tags",
                            multiple: true,
                            size: "small",
                            fullWidth: false,
                            sx: {
                                minWidth: {
                                    md: 200,
                                    xs: 150
                                }
                            },
                            label: translate("label.topic"),
                            options: tags === null || tags === void 0 ? void 0 : tags.map(function(param) {
                                var id = param.id, title = param.title;
                                return {
                                    id: id,
                                    title: title
                                };
                            }),
                            onInputChange: handleFilterTitleTag,
                            loading: isLoadingTag
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                            size: "small",
                            type: "submit",
                            variant: "contained",
                            loading: isSubmitting,
                            sx: {
                                minWidth: 100
                            },
                            children: translate("button.question")
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 95466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QuestionSection; },
/* harmony export */   "d": function() { return /* binding */ QuestionPosts; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10633);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var _components_EmptyContent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77251);
/* harmony import */ var _components_skeleton_SkeletonItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37549);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9671);
/* harmony import */ var _redux_slices_blog_blog_question__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29061);
/* harmony import */ var _QuestionCard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15250);
/* harmony import */ var _QuestionHeaderToolbar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72579);
/* harmony import */ var _QuestionInfo__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54273);
/* harmony import */ var _QuestionNewForm__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40183);
// @mui




//










// ----------------------------------------------------------------------
function QuestionSection() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
        container: true,
        spacing: 3,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
            item: true,
            xs: 12,
            md: 12,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_QuestionInfo__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_QuestionNewForm__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_QuestionHeaderToolbar__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuestionPosts, {})
            ]
        })
    });
}
function QuestionPosts() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().translate;
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.blogQuestion;
    }), questions = ref.questions, search = ref.search, totalPages = ref.totalPages, isLoading = ref.isLoading, numberOfElements = ref.numberOfElements;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timeout = setTimeout(function() {
            dispatch((0,_redux_slices_blog_blog_question__WEBPACK_IMPORTED_MODULE_6__/* .getQuestions */ .tI)());
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        search
    ]);
    var handleChangePage = function(_, page) {
        dispatch((0,_redux_slices_blog_blog_question__WEBPACK_IMPORTED_MODULE_6__/* .setQuestionSearch */ .y4)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, search), {
            page: page - 1
        })));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        spacing: 3,
        children: [
            questions.map(function(question) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_QuestionCard__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    question: question
                }, question.id);
            }),
            isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_skeleton_SkeletonItem__WEBPACK_IMPORTED_MODULE_4__/* .SkeletonSolutionItem */ .Fg, {}) : numberOfElements == 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_EmptyContent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                description: translate("label.noSolution")
            }),
            numberOfElements > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                alignItems: "center",
                my: 1.5,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    count: totalPages,
                    variant: "text",
                    page: search.page + 1,
                    onChange: handleChangePage
                })
            })
        ]
    });
}


/***/ })

}]);